import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import BaseForm from 'components/base/v2/BaseForm';
import { APIStatus } from 'config/CustomEnums';
import {
  removeLevelSessionStroage,
  saveLevelToSessionStorage,
  sessionDataKey,
} from 'models/LevelModel';
import CreateLevelStepOne from './CreateLevelStepOne';
import CreateLevelStepTwo from './CreateLevelStepTwo';


function CreateLevel({
  stepConfig,
  currentStep,
  detail = {},
  formHasSubmitted,
  hasUpdatedDefaultValues,
  createLevelStatus,
}) {
  const params = useParams();
  const levelId = params.id;
  const dispatch = useDispatch();
  const history = useHistory();

  const levelGeneralName = detail.translations?.en?.levelName;

  useEffect(() => {
    dispatch({ type: 'levels/clearData' });
    dispatch({
      type: 'levels/getLevelGlobalSetting',
      payload: {},
    });
    dispatch({
      type: 'levels/getList',
      payload: {
        isListApi: true,
      }
    });
    if (levelId) {
      dispatch({
        type: 'levels/getOneDetail',
        payload: {
          id: levelId,
        }
      });
    } else {
      dispatch({
        type: 'levels/loadFromCookie',
        payload: {},
      });
    }
    dispatch({
      type: 'language/getList',
      payload: { isSelectorLoad: true }
    });
    return () => {
      dispatch({ type: 'levels/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stepSet = [
    <CreateLevelStepOne />,
    <CreateLevelStepTwo />,
  ];

  const toLevelList = () => {
    history.push({ pathname: '/levels' });
  };

  return (
    <BaseForm
      defaultValues={detail}
      formHasSubmitted={formHasSubmitted}
      hasUpdatedDefaultValues={hasUpdatedDefaultValues}
      tempSave={(save, getValues) => {
        if (save) {
          saveLevelToSessionStorage(getValues());
        } else {
          removeLevelSessionStroage();
        }
      }}
      showFinishPop={createLevelStatus === APIStatus.success}
      nextStepConfig={{
        title: 'Successfully created!',
        description: 'Level is successfully created.',
        steps: null,
        onHide: () => { },
        buttons: [
          {
            text: 'Back to levels list',
            action: toLevelList,
          },
        ],
      }}
      continueCreateConfig={{
        onConfirm: () => {
          history.push(history.location.state?.from);
        },
        onCancel: toLevelList,
        onClose: toLevelList,
      }}
      sessionDataKey={sessionDataKey}
      content={stepSet}
      currentStep={currentStep}
      breadcrumb={<CustomBreadcrumb name={levelId ? levelGeneralName : 'Create level'} />}
      stepsConfig={stepConfig}
      caution={{
        detail: '',
        title: levelId ? levelGeneralName : 'Create level',
      }}
      hasleavePagePrompt={params.id}
    />
  );
}

const mapPropsToState = (state) => ({
  stepConfig: state.levels.stepConfig,
  currentStep: state.levels.currentStep,
  detail: state.levels.detail,
  formHasSubmitted: state.levels.formHasSubmitted,
  hasUpdatedDefaultValues: state.levels.hasUpdatedDefaultValues,
  createLevelStatus: state.levels.createLevelStatus,
});

export default connect(mapPropsToState)(CreateLevel);
